export default (t) => [
  {
    text: t('Document No.'),
    value: 'adjustment_no',
    sortable: false,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Date'),
    value: 'transaction_date',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 75,
    togglable: true
  },
  {
    text: t('Reason'),
    value: 'reason',
    sortable: false,
    width: 80,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'status',
    sortable: true,
    width: 50,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 30
  },
];
